<template>
  <div class='right-list-wrap'>
    <div class='title a-text-17 a-lightblack a-text-center'>
      <div style='position: relative; z-index: 100'>{{levelName}}会员权益</div>
      <div class='text-bg'></div>
    </div>
    <div class='right-list fx-row fx-wrap'>
      <div class='right-list-item fx-col fx-center' v-for="(item, index) in list" :key='index' @click='showRightExplain(item.opacity, item.describe, item.windowDesc, item.minLevel)'>
        <div class='top-panel a-text-22 fx-row fx-c-center'>
          <div class='price a-text-bold' v-if="item.opacity === '1' && item.describevalue">
            <span class='currency a-text-11 a-lightblack a-text-regular' v-if='item.describepre'>¥</span>{{item.describevalue}}<span class='small-text a-text-11 a-gray a-text-regular' v-if="item.describeunit">{{item.describeunit}}</span>
          </div>
          <img src='https://cdn.133.cn/gtgj/vipcard/customer-service.png' alt='' class='icon-service' v-else-if="item.opacity === '1' && !item.describevalue"  />
          <img src='https://cdn.133.cn/gtgj/vipcard/icon_lock.png' alt='' class='icon-lock' v-else/>
          <img :src="item.describeicon" alt="" class='icon-limit' v-if="item.describeicon" />
        </div>
        <div class='bot-panel a-text-12' :class="[item.opacity === '1' ? 'a-gray' : 'gray-c' ]">{{item.describe}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    currentIndex: {
      type: [String, Number],
      required: true
    },
    list: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    levelName: {
      type: String,
      required: true
    }
  },
  
  methods: {
    showRightExplain( isOwn, name, value, minLevel ) {
      if ( isOwn === '1' ) {
        this.$popup({
          title: name,
          content: value,
          confirmButtonText: '我知道了'
        })
      } else {
        this.$emit('change-modal-status', {
          type: 'vip',
          value: true,
          level: minLevel
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.right-list-wrap {
  background: #ffffff;
  margin-bottom: 8 * $px;
  .icon-lock {
    width: 20 * $px;
    height: 24 * $px;
    display: block;
  }
  .icon-service {
    width: 23 * $px;
    height: 24 * $px;
  }
  .icon-limit {
    width: 30 * $px;
    height: 13 * $px;
    position: absolute;
    right: 14 * $px;
    top: 8 * $px;
  }
  .gray-c {
    color: #cccccc;
  }
  .title {
    line-height: 24 * $px;
    position: relative;
    margin-top: -15 * $px;
    margin-bottom: 10 * $px;
    .text-bg {
      display: block;
      content: '';
      width: 102 * $px;
      height: 12 * $px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      background: #ffe6c2;
      z-index: 1;
    }
  }
  .right-list-item {
    width: 25%;
    height: 75 * $px;
    border-top: 0.5 * $px solid #ebebeb;
    border-right: 0.5 * $px solid #ebebeb;
    box-sizing: border-box;
    position: relative;
    &:nth-child(4n) {
      border-right: 0 none;
    }
    .currency {
      vertical-align: top;
      display: inline-block;
      line-height: 22 * $px;
      margin-right: 1 * $px;
    }
    .top-panel {
      height: 30 * $px;
      margin-bottom: 2 * $px;
      color: #313235;
    }
    .bot-panel {
      line-height: 17 * $px;
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/components/home-rights-list.vue